import React from "react";
import PPCNavbar from "../PPC/nav/navbar";
import PPCHero from "./hero/hero";
import About from "./about/about";
import Service from "./service/service";
import Dentist from "./dentist/dentist";
import Testimonial from "../Testimonial/Testimonial";
import Appointment from "../Appointment/Appointment";
import Footer from "../Footer/Footer";
import Scroll from "../scroll/scroll";

const PPCLayout = ({ children }) => {
  return (
    <>
      <PPCNavbar />
      <PPCHero />
      <About />
      <Service />
      <Dentist />
      <Testimonial />
      <Appointment />
      <Footer />
      <Scroll />
    </>
  );
};

export default PPCLayout;
